import request from '@/utils/request';

export const productImgTemplateDel = (data: any): any =>
  request({
    url: '/pc/productImgTemplate/del',
    data: data
  })

export const productImgTemplateSetDefault = (data: any): any =>
  request({
    url: '/pc/productImgTemplate/setDefault',
    data: data
  })

export const productImgTemplateList = (data: any): any =>
  request({
    url: '/pc/productImgTemplate/list',
    data: data
  })

export const productImgTemplateSave = (data: any): any =>
  request({
    url: '/pc/productImgTemplate/save',
    data: data
  })

export const productCrossBuyErpList = (data: any): any =>
  request({
    url: '/pc/prodcut/productCrossBuyErpList',
    data: data
  })

// 商品选择规格图片层级记录
export const specImgSelectLeveLog = (data: any): any =>
  request({
    url: '/pc/product/specImgSelectLeveLog',
    data: data
  })

// 供应商列表
export const supplierList = (data: any): any =>
  request({
    url: '/pc/provider/list',
    data: data
  })
// 供应商列表-不分页
export const providerSelectItem = (data: any): any =>
  request({
    url: '/pc/provider/providerSelectItem',
    data: data
  })

// 新增供应商
export const creareSupplier = (data: any): any =>
  request({
    url: '/pc/provider/save',
    data: data
  })

// 供应商详情
export const supplierInfo = (data: any): any =>
  request({
    url: '/pc/provider/detail',
    data: data
  })

// 设置供应商
export const setSupplier = (data: any): any =>
  request({
    url: '/provider/set',
    data: data
  })

// 供应商统计
export const getProviderStatistics = (data: any): any =>
  request({
    url: '/pc/provider/sellStatis',
    data: data
  })

// 供应商统计_详情列表
export const getProviderProductEarnings = (data: any): any =>
  request({
    url: '/pc/provider/sellStatisByProduct',
    data: data
  })

// 商品列表
export const productList = (data: any): any =>
  request({
    url: '/pc/product/productList',
    data: data
  })

// 商品详情
export const productInfo = (data: any): any =>
  request({
    url: '/pc/product/productInfo',
    data: data
  })

// 
export const productChangeSpecAndJoinActivityOnePrice = (data: any): any =>
  request({
    url: '/pc/prodcut/productChangeSpecAndJoinActivityOnePrice',
    data: data
  })

  // 获取审核通过且有统计编码的商品
export const checkPassAndHaveStatisticalNoProductList = (data: any): any =>
  request({
    url: '/pc/product/checkPassAndHaveStatisticalNoProductList',
    data: data
  })

 // 通过编码查询商品
export const productInfoByStatisticalNo = (data: any): any =>
  request({
    url: '/pc/product/productInfoByStatisticalNo',
    data: data
  })

// 创建商品
export const createProduct = (data: any): any =>
  request({
    url: '/pc/product/saveProduct',
    data: data
  })

// 获取单位列表
export const productUnitList = (data: any): any =>
  request({
    url: '/pc/product/productUnitList',
    data: data
  })

// 更新商品
export const updateProduct = (data: any): any =>
  request({
    url: '/product/update',
    data: data
  })

// 删除商品
export const delProduct = (data: any): any =>
  request({
    url: '/product/delete',
    data: data
  })

//供应商商品审核列表
export const getProviderProductCheckList = (data: any): any =>
  request({
    url: '/pc/product/providerProductCheckList',
    data
  })

//供应商商品审核列表_审核通过
export const providerProductCheckSuccess = (data: any): any =>
  request({
    url: '/pc/product/providerProductCheckSuccess',
    data
  })

//供应商商品审核列表_审核驳回
export const providerProductCheckReject = (data: any): any =>
  request({
    url: '/pc/product/providerProductCheckReject',
    data
  })

// 复购申请记录列表
export const getRepeatePayRecordList = (data: any): any =>
request({
  url: '/repeated/pay/recordlist',
  data
})

// 团队管理
export const getTeamList = (data: any): any =>
request({
  url: '/pc/member/memberTeam',
  data
})

// 一键复制商品
export const copyProduct = (data: any): any =>
  request({
    url: '/product/copy',
    data
  })

// 上下架
export const productOpen = (data: any): any =>
request({
  url: '/pc/product/open',
  data
})

export const getSkusByProductId = (data: any): any =>
  request({
    url: '/pc/product/productBuyMoreDealsInfo',
    data
  })

// 创建活动插件
export const createActivity = (data: any): any =>
  request({
    url: '/pc/product/saveProductBuyMoreDeals',
    data
  })

// 更新活动插件
export const updateActivity = (data: any): any =>
  request({
    url: '/product/plugin/update',
    data
  })

// 删除活动插件
export const deleteActivity = (data: any): any =>
  request({
    url: '/pc/product/deleteProductBuyMoreDealsInfo',
    data
  })

// 获取活动插件
export const getActivity = (data: any): any =>
  request({
    url: '/pc/product/productBuyMoreDealsInfo',
    data
  })

// 商品分类
export const productCategory = (data: any): any =>
  request({
    url: '/pc/product/productCategory',
    data
  })

  // 添加分类
export const productCategorySave = (data: any): any =>
  request({
    url: '/pc/product/productCategorySave',
    data
  })

// 删除分类
export const productCategoryDelete = (data: any): any =>
  request({
    url: '/pc/prodcut/productCategoryDelete',
    data
  })


export const productCategoryIsOpenProductRetrieval = (data: any): any =>
  request({
    url: '/pc/prodcut/productCategoryIsOpenProductRetrieval',
    data
  })

  // 加入专区排行
export const productCategoryIsJoinZoneRank = (data: any): any =>
  request({
    url: '/pc/prodcut/productCategoryIsJoinZoneRank',
    data
  })

// 许愿商品
export const productWishList = (data: any): any =>
  request({
    url: '/pc/product/productWishList',
    data
  })

// 热门许愿商品
export const producthotWishInfo = (data: any): any =>
  request({
    url: '/pc/product/hotWishInfo',
    data
  })


// 商品-定时上下架
export const producttimedUpAndDown = (data: any): any =>
  request({
    url: '/pc/product/timedUpAndDown',
    data
  })

// 设置销量系数
export const productsetSalesCoefficient = (data: any): any =>
  request({
    url: '/pc/product/setSalesCoefficient',
    data
  })

// 供应商审核通过
export const providercheckSuccess = (data: any): any =>
  request({
    url: '/pc/provider/checkSuccess',
    data
  })
  
// 供应商审核驳回
export const providercheckReject = (data: any): any =>
request({
  url: '/pc/provider/checkReject',
  data
})
  
// 供应商商品初审通过
export const productproviderProductFirstTrialSuccess = (data: any): any =>
request({
  url: '/pc/product/providerProductFirstTrialSuccess',
  data
})  
// 供应商商品已寄样审核通过
export const productproviderProductSendCheckSuccess = (data: any): any =>
request({
  url: '/pc/product/providerProductSendCheckSuccess',
  data
})  
// 供应商商品初审驳回
export const productproviderProductFirstTrialFail = (data: any): any =>
request({
  url: '/pc/product/providerProductFirstTrialFail',
  data
})  
// 供应商商品已寄样审核驳回
export const productproviderProductSendCheckFail = (data: any): any =>
request({
  url: '/pc/product/providerProductSendCheckFail',
  data
})  
// 供应商商品待复审审核驳回
export const productproviderProductReCheckFail = (data: any): any =>
request({
  url: '/pc/product/providerProductReCheckFail',
  data
})  
// 供应商商品待复审审核通过
export const productproviderProductReCheckPass = (data: any): any =>
request({
  url: '/pc/product/providerProductReCheckPass',
  data
})


// 库存预警
export const productproductStockWarning = (data: any): any =>
request({
  url: '/pc/product/productStockWarning',
  data
})

// 库存预警
export const productproductSpecStockRecordPageList = (data: any): any =>
request({
  url: '/pc/product/productSpecStockRecordPageList',
  data
})

// 商品售后配置
export const productsaveProductAfterSaleConfig = (data: any): any =>
request({
  url: '/pc/product/saveProductAfterSaleConfig',
  data
})
// 供应商商品审核记录
export const productproviderProductCheckRecord = (data: any): any =>
request({
  url: '/pc/product/providerProductCheckRecord',
  data
})




// 重置供应商密码
export const providerresetPassword = (data: any): any =>
request({
  url: '/pc/provider/resetPassword',
  data
})


// 商品筛选列表 团购价有区间的
export const productpopoverproductlist = (data: any): any =>
request({
  url: '/pc/product/popoverproductlist',
  data: data
})

// 商品筛选列表
export const productfilterBoxList = (data: any): any =>
request({
  url: '/pc/product/filterBoxList',
  data: data
})


// 供应商开启-关闭加密导出手机号
export const providerisEncryptExportPhone = (data: any): any =>
request({
  url: '/pc/provider/isEncryptExportPhone',
  data: data
})

// 修改是否显示商品海报图
export const producteidtIsShowPoster = (data: any): any =>
request({
  url: '/pc/product/eidtIsShowPoster',
  data: data
})



// 获取ERP配置
export const providerproviderErpConfig = (data: any): any =>
request({
  url: '/pc/provider/providerErpConfig',
  data: data
})
// 保存ERP配置
export const providerproviderErpConfigSave = (data: any): any =>
request({
  url: '/pc/provider/providerErpConfigSave',
  data: data
})


// 发送上架通知
export const productsendProductUpMessage = (data: any): any =>
request({
  url: '/pc/product/sendProductUpMessage',
  data: data
})
// 修改供货商首款结算比例
export const providerproviderFirstSettlementRateSave = (data: any): any =>
request({
  url: '/pc/provider/providerFirstSettlementRateSave',
  data: data
})
// 修改商品开团时间
export const productproductOpeningTimeEdit = (data: any): any =>
request({
  url: '/pc/product/productOpeningTimeEdit',
  data: data
})



// 获取采购列表
export const productBuyerproductBuyerPageInit = (data: any): any =>
request({
	url: '/pc/productBuyer/productBuyerPageInit',
	data: data
})
// 采购人员删除
export const productBuyerproductBuyerDelete = (data: any): any =>
request({
	url: '/pc/productBuyer/productBuyerDelete',
	data: data
})
//采购人员信息保存
export const productBuyerproductBuyerSave = (data: any): any =>
request({
	url: '/pc/productBuyer/productBuyerSave',
	data: data
})



//分销员标签管理
export const memberLabelmemberLabelManager = (data: any): any =>
request({
	url: '/pc/memberLabel/memberLabelManager',
	data: data
})
//分销员标签删除 
export const memberLabelmemberLabelDelete = (data: any): any =>
request({
	url: '/pc/memberLabel/memberLabelDelete',
	data: data
})
//分销员标签保存
export const memberLabelmemberLabelSave = (data: any): any =>
request({
	url: '/pc/memberLabel/memberLabelSave',
	data: data
})
//分销员标签使用详情
export const memberLabelmemberLabelUseDetail = (data: any): any =>
request({
	url: '/pc/memberLabel/memberLabelUseDetail',
	data: data
})



//银行列表分页(财务结算用的)
export const bankFinanceSettlepagelist = (data: any): any =>
request({
  url: '/pc/bankFinanceSettle/pagelist',
  data: data
})
//银行详情(财务结算用的)
export const bankFinanceSettledetail = (data: any): any =>
request({
  url: '/pc/bankFinanceSettle/detail',
  data: data
})
//银行保存(财务结算用的) 
export const bankFinanceSettlesave = (data: any): any =>
request({
  url: '/pc/bankFinanceSettle/save',
  data: data
})


//获取排期商品详情
export const productscheduleProductDetail = (data: any): any =>
request({
  url: '/pc/product/scheduleProductDetail',
  data: data
})
//获取商品供货商供货价
export const productproductProviderSupplyPrice = (data: any): any =>
request({
  url: '/pc/product/productProviderSupplyPrice',
  data: data
})


export const productOpenTimeLabelFilterList = (data: any): any =>
request({
  url: '/pc/product/productOpenTimeLabelFilterList',
  data: data
})
